import { cn } from '@/lib/cn';
import { type LabelHTMLAttributes } from 'react';

type Props = LabelHTMLAttributes<HTMLLabelElement>;

export function Label({ className, ...props }: Props) {
  return (
    <label
      className={cn('block text-sm font-medium text-[var(--fv-text)]', className)}
      {...props}
    />
  );
}
